import { __rest } from 'tslib';
import React from 'react';
import { useTheme, useColor } from '@10d/tend-ui-theme';
import { Root } from './styled.js';
import { useSizeContext } from '../../contexts/SizeContext.js';

const Main = (_a) => {
    var { children, className, background } = _a, props = __rest(_a, ["children", "className", "background"]);
    const theme = useTheme();
    const { size } = useSizeContext();
    // FIXME: Поправить литеральные типы
    const _background = useColor(background, 'white');
    return (React.createElement(Root, Object.assign({}, props, { theme: theme, "$size": size, "$background": _background, className: ['tend-ui-layout-main', className].filter(Boolean).join(' ') }), children));
};
Main.displayName = 'Layout.Main';

export { Main };
